module.exports = __webpack_public_path__ + "img/camara_courier.581144b4.svg";